
let DroneBridge = function(){
  this.currentAccount = {}
  this.currentConnection = {}

  this.authenticatedToken = () => new Promise((res, rej) => {
    // const channel = new MessageChannel(); 
    var f = (event) => {
      if(event.data.namespace == 'drone/authToken'){
        window.removeEventListener("message", f, false)
        if(event.data.error){
          rej(event.data.error)
        } else{
          res(event.data)
        }
      }
    }
    addEventListener("message", f, false)

    // channel.port1.onmessage = ({data}) => {
    //   channel.port1.close();
    //   if (data.error) {
    //     rej(data.error);
    //   }else {
    //     res(data.result);
    //   }
    // };

    window.parent.postMessage({
      client_id: this.currentConnection.client_id, 
      account_id: this.currentConnection.account_id
    }, '*');
  });

  this.init = (obj) => {
    this.currentConnection = obj
  }

  this.redirectUrl = async (url) => {
    const sessionToken = await this.authenticatedToken()
    const token = sessionToken.result.token
    if (!url.startsWith('http'))  {
      if (!url.startsWith('/')){
        url = '/' + url
      }
      url = document.location.origin + url
    }
    let urlObj = new URL(url)
    console.log(token)
    urlObj.searchParams.set('token', token)
    urlObj.searchParams.set('account_id', this.currentConnection.account_id)
    return urlObj.href
  }
}

export default function initConnection(obj){
  let DroneApp = new DroneBridge()
  DroneApp.init(obj)
  return DroneApp
}
